import { useTranslation } from '../i18n';

import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Card, Result, Spin } from 'antd';
import apiClient from '../services/apiClient';

/**
 * 邮件转发确认页 /forward-verify?token=xxx(公开,收件方无需登录)
 */
const ForwardVerify = () => {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const [state, setState] = useState(token ? { status: 'verifying' } : { status: 'error' });

    // token 可重复确认,但 StrictMode 下仍只请求一次
    const requestedRef = useRef(false);

    useEffect(() => {
        if (!token || requestedRef.current) return;
        requestedRef.current = true;
        (async () => {
            try {
                const res = await apiClient.post('/auth/forward-verify', { token }, { skipGlobalErrorToast: true });
                const d = res.data || {};
                setState(d.success || d.code === 0 ? { status: 'success', ...(d.data || {}) } : { status: 'error', message: d.error || d.message });
            } catch (e) {
                setState({ status: 'error', message: e.response?.data?.error });
            }
        })();
    }, [token]);

    let content;
    if (state.status === 'verifying') {
        content = <div style={{ textAlign: 'center', padding: '32px 0' }}><Spin size="large" /></div>;
    } else if (state.status === 'success') {
        content = (
            <Result
                status="success"
                title={t('Forwarding confirmed')}
                subTitle={t('Mail sent to {{source}} will be forwarded to {{address}}.', { source: state.source, address: state.address })}
            />
        );
    } else {
        content = <Result status="error" title={t('Confirmation failed')} subTitle={t(state.message || '链接无效')} />;
    }

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#f0f2f5', padding: 16 }}>
            <Card style={{ width: 440, maxWidth: '100%', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>{content}</Card>
        </div>
    );
};

export default ForwardVerify;
